module.exports = __webpack_public_path__ + "img/close.fa9d01b6.png";